import type { AutomationId } from "@repo/app-types/entities/automation";
import { AutomationRunsTable } from "@repo/ui/automations/automationRunsTable";
import type { FC } from "react";
import { useNavigate } from "react-router";
import { useAutomationRunsQuery } from "../../api/entities/automationRun.js";
import { useAgentDetailOutletContext } from "./agentDetailPage.js";

export const AgentRunsTab: FC = () => {
  const { automation } = useAgentDetailOutletContext();
  const navigate = useNavigate();

  return (
    <div className="flex w-full flex-col gap-4">
      <RunsView
        automationId={automation.id}
        onRunAction={(runId) => {
          navigate(`../runs/${encodeURIComponent(runId)}`);
        }}
      />
    </div>
  );
};

const RunsView: FC<{
  automationId: AutomationId;
  onRunAction: (runId: string) => void;
}> = ({ automationId, onRunAction }) => {
  // Refetch on (re)mount so a run started or finished while the user was away —
  // e.g. watching a run and navigating back — shows up without a manual reload.
  const { data: runs, isLoading } = useAutomationRunsQuery(automationId, {
    refetchOnMountOrArgChange: true,
  });

  return (
    <AutomationRunsTable
      runs={runs}
      isLoading={isLoading}
      onRunAction={(run) => {
        onRunAction(run.id);
      }}
    />
  );
};
